












import { Vue, Prop, Component } from 'vue-property-decorator'
import { TestEntry } from '@/testset'
import LogView from '@/components/LogView.vue'

@Component({
  components: {
    LogView
  }
})
export default class extends Vue {
  @Prop({ required: true }) result!: TestEntry[]
}
